// extracted by mini-css-extract-plugin
export default {"facebook-btn":"Button_facebook-btn__PXB9y","twitter-btn":"Button_twitter-btn__QGdR4","selected":"Button_selected__i00rX"};